var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3013_5514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.97204 0 0 8.97204 0 20C0 31.0271 8.97204 40 20 40C31.0271 40 40 31.0271 40 20C40 8.97204 31.0288 0 20 0ZM24.9738 20.7041H21.72V32.3016H16.8984C16.8984 32.3016 16.8984 25.9647 16.8984 20.7041H14.6065V16.6052H16.8984V13.9539C16.8984 12.0551 17.8007 9.08805 21.7643 9.08805L25.3371 9.10175V13.0806C25.3371 13.0806 23.166 13.0806 22.7439 13.0806C22.3218 13.0806 21.7216 13.2917 21.7216 14.1972V16.606H25.3951L24.9738 20.7041Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3013_5514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.6b3d737244f770bc2477b9a3d95002be.svg";
export { ForwardRef as ReactComponent };